const sameSlice = (item, slice) => Number(item?.slice ?? slice) === Number(slice);

const latestForSlice = (items = [], slice = 0) => {
  for (let i = items.length - 1; i >= 0; i -= 1) {
    if (sameSlice(items[i], slice)) return items[i];
  }
  return null;
};

const subjectOrderValue = (item) => Number(item?.updatedAt ?? item?.createdAt ?? item?.id ?? 0);

export const selectReportContextSubjects = ({ measurements = [], rois = [], slice = 0 } = {}) => ({
  measurement: latestForSlice(measurements, slice),
  roi: latestForSlice(rois, slice),
});

export const chooseReportContextKind = ({ kindOverride = null, measurement = null, roi = null } = {}) => {
  if (kindOverride) return kindOverride;
  if (measurement && roi) {
    return subjectOrderValue(measurement) > subjectOrderValue(roi) ? 'measurement' : 'roi';
  }
  if (roi) return 'roi';
  if (measurement) return 'measurement';
  return 'keyImage';
};
